export { default } from './SectionContainer';